import { ReturnCollection, ReturnCollectionFromJSON } from '@/api'
import * as runtime from '../runtime'

export class ReturnHistoriesApi extends runtime.BaseAPI {
  /**
   * 返却履歴を取得する
   * 返却履歴取得
   */
  async getReturnHistories(): Promise<ReturnCollection[]> {
    const response = await this.requestGet('/return-histories')

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(ReturnCollectionFromJSON)
    ).value()
  }
}
